<template>
  <div class="login-register-container" @click="handleContainerClick">
    <!-- Background image container -->
    <div class="background-image"></div>

    <!-- Common Header (Always Visible) -->
    <div class="common-header">
      <!-- Top Logo -->
      <div class="top-logo-container">
        <!-- Use dynamic logo from store if available, otherwise fallback -->
        <img :src="$store.state.appInfo.site_logo ? $store.state.appInfo.site_logo : '/static/image/hth/logo.png'" alt="Logo" class="top-logo" />
        <div class="logo-text">{{ $store.state.appInfo.title || '华体会' }}<div class="url">91fa.net</div></div>
        
      </div>
      <!-- Partner Block -->
      <!-- <div class="partner-block">
        <img src="/static/image/hth/partners.png" alt="合作伙伴" class="partner-image">
      </div> -->
      <div class="wel">欢迎光临开云娱乐；<br/>USDT上下分，匿名投注/取款提款0审核 秒到账</div>
    </div>

    <!-- Unified View Container (Replaces separate login/register views) -->
    <div class="unified-view">
      <!-- Unified Form -->

      <van-tabs v-model="active" @change="changeTab" color="#866638" title-active-color="#866638" >
        <van-tab >
          <template #title ><div style="display: flex;align-items: center;"> <svg width="1.5em" height="1.5em" fill="currentColor" class="" viewBox="0 0 50 48">
  <g id="fefd6c7fa54dfad8f9e5d468c844f2a4-login_icon_zj" transform="translate(1)">
    <rect id="fefd6c7fa54dfad8f9e5d468c844f2a4-矩形_2" data-name="矩形 2" width="48" height="48" opacity="0"></rect>
    <path id="fefd6c7fa54dfad8f9e5d468c844f2a4-路径_15109" data-name="路径 15109" d="M21014.859-2679.447a3.821,3.821,0,0,1-2.77-1.184,3.965,3.965,0,0,1-1.084-2.9,20.067,20.067,0,0,1,2.277-8.145,20.061,20.061,0,0,1,3.039-4.328,19.723,19.723,0,0,1,4.662-3.7l.645-.375.533.512a13.858,13.858,0,0,0,9.619,3.864,13.845,13.845,0,0,0,9.619-3.864l.533-.512.641.375a19.6,19.6,0,0,1,2.441,1.649,11.928,11.928,0,0,0-5.809,10.211,11.789,11.789,0,0,0,3.479,8.393v.005Zm34.242-2.463v-3.958h-3.959a1.977,1.977,0,0,1-1.977-1.977,1.978,1.978,0,0,1,1.977-1.982h3.959v-3.958a1.977,1.977,0,0,1,1.98-1.977,1.974,1.974,0,0,1,1.979,1.977v3.958h3.957a1.983,1.983,0,0,1,1.982,1.982,1.982,1.982,0,0,1-1.982,1.977h-3.957v3.958a1.979,1.979,0,0,1-1.979,1.982A1.982,1.982,0,0,1,21049.1-2681.91Zm-25.6-19.291a11.469,11.469,0,0,1-3.43-8.2,11.49,11.49,0,0,1,3.43-8.208,11.72,11.72,0,0,1,8.281-3.388,11.7,11.7,0,0,1,8.271,3.388,11.472,11.472,0,0,1,3.436,8.208,11.451,11.451,0,0,1-3.436,8.2,11.663,11.663,0,0,1-8.271,3.4A11.686,11.686,0,0,1,21023.5-2701.2Z" transform="translate(-21011.002 2724.001)" stroke-width="2"></path>
  </g>

</svg><span style="font-size: 16px;">注册</span></div> </template>
        </van-tab>
        <van-tab>
          <template #title > <div style="display: flex;align-items: center;"><svg width="1.5em" height="1.5em" fill="currentColor" class="" viewBox="0 0 48 48">
  <rect id="e11d98aa4388e95a9732ec9bf39e3046-矩形_2" data-name="矩形 2" width="48" height="48" opacity="0"></rect>
  <path id="e11d98aa4388e95a9732ec9bf39e3046-路径_15110" data-name="路径 15110" d="M25.409,41.914V2.083A2.081,2.081,0,0,1,27.483,0a1.97,1.97,0,0,1,.692.12l12.3,4.321a2.087,2.087,0,0,1,1.39,1.966V37.593a2.082,2.082,0,0,1-1.39,1.962l-12.3,4.325a2.071,2.071,0,0,1-2.766-1.966ZM8.369,40.8a1.735,1.735,0,0,1-1.732-1.733V26.628H10.1v10.7H20.427a1.783,1.783,0,0,1,1.8,1.686A1.732,1.732,0,0,1,20.5,40.8Zm5.145-14.742V23.589H1.73A1.729,1.729,0,0,1,0,21.8a1.779,1.779,0,0,1,1.8-1.682h11.71V17.648a1.159,1.159,0,0,1,1.853-.929l5.619,4.2a1.162,1.162,0,0,1,0,1.861l-5.619,4.208a1.144,1.144,0,0,1-.687.23A1.161,1.161,0,0,1,13.514,26.061Zm-6.878-8.98V4.643A1.736,1.736,0,0,1,8.369,2.906H20.5A1.733,1.733,0,0,1,22.23,4.7a1.779,1.779,0,0,1-1.8,1.678H10.1v10.7Z" transform="translate(3 2)" stroke-width="1"></path>

</svg> <span style="font-size: 16px;">登录</span></div> </template>
        </van-tab>
      </van-tabs>


      <div class="unified-form">
        <!-- Username Input (Always Visible) -->
        <div class="input-wrapper">
          <div class="input-group">
            <!-- <img src="/static/image/hth/user.png" alt="User Icon" class="input-icon" /> -->
             <svg width="1.5em" height="1.5em" fill="#999" class="" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="e63488119c37f6525964ba95be14d119-clip-path">
                  <path id="e63488119c37f6525964ba95be14d119-Union_151" data-name="Union 151" d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"></path>
                </clipPath>
              </defs>
              <g id="e63488119c37f6525964ba95be14d119-input_icon_zh" transform="translate(-2322 -2123)">
                <g id="e63488119c37f6525964ba95be14d119-底层" transform="translate(2322 2123)">
                  <g id="e63488119c37f6525964ba95be14d119-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0" clip-path="url(#e63488119c37f6525964ba95be14d119-clip-path)">
                    <path id="e63488119c37f6525964ba95be14d119-底层-2" data-name="底层" d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z" transform="translate(0 0)"></path>
                  </g>
                </g>
                <path id="e63488119c37f6525964ba95be14d119-icon_dl_zh" d="M4.328,46.837A3.348,3.348,0,0,1,1,43.473v-.147A22.079,22.079,0,0,1,12.009,25.609a17.332,17.332,0,0,0,23.875,0A22.072,22.072,0,0,1,46.87,43.326,3.344,3.344,0,0,1,43.7,46.833h-.149Zm7.185-33.4A12.419,12.419,0,1,1,24.054,25.675h-.119A12.327,12.327,0,0,1,11.513,13.442Z" transform="translate(2322 2123.163)"></path>
              </g>
            </svg>
            <span style="color: red;">*</span>
            <!-- Bind to computed property -->
            <input type="text" v-model="username" placeholder="请输入账号" autocomplete="off" />
            <div class="input-hint" v-if="infoType === 1">用户名长度限制5-11位小写字母加数字组合</div>
          </div>
          
        </div>

        <!-- Password Input (Always Visible) -->
        <div class="input-wrapper">
          <div class="input-group">
            <!-- <img src="/static/image/hth/password.png" alt="Password Icon" class="input-icon" /> -->
             <svg width="1.5em" height="1.5em" fill="#999" class="" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="4cf847dfebf12c64dedd56f54eef55f5-clip-path">
                  <path id="4cf847dfebf12c64dedd56f54eef55f5-Union_151" data-name="Union 151" d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"></path>
                </clipPath>
              </defs>
              <g id="4cf847dfebf12c64dedd56f54eef55f5-input_icon_mm" transform="translate(-1283 -2123)">
                <g id="4cf847dfebf12c64dedd56f54eef55f5-底层" transform="translate(1283 2123)">
                  <g id="4cf847dfebf12c64dedd56f54eef55f5-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0" clip-path="url(#4cf847dfebf12c64dedd56f54eef55f5-clip-path)">
                    <path id="4cf847dfebf12c64dedd56f54eef55f5-底层-2" data-name="底层" d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z" transform="translate(0 0)"></path>
                  </g>
                </g>
                <path id="4cf847dfebf12c64dedd56f54eef55f5-icon_dl_mm" d="M3395.9,1308.251v-3.45a13.723,13.723,0,0,0-12.842-13.8,13.492,13.492,0,0,0-14.205,13.4v3.832h-.542a3.307,3.307,0,0,0-3.32,3.293v22.161a3.307,3.307,0,0,0,3.32,3.294h28.129a3.308,3.308,0,0,0,3.32-3.294v-22.161a3.307,3.307,0,0,0-3.32-3.293Zm-22.541-3.514a9.014,9.014,0,1,1,18.027,0v3.515H3373.36Zm11.908,23.534a.943.943,0,0,1-.23.743.973.973,0,0,1-.72.32h-3.862a.973.973,0,0,1-.722-.32.947.947,0,0,1-.23-.742l.61-5.438a3.777,3.777,0,0,1-1.582-3.082,3.863,3.863,0,1,1,7.727,0,3.777,3.777,0,0,1-1.58,3.082Z" transform="translate(-2075.991 833.018)"></path>
              </g>
            </svg>
            <span style="color: red;">*</span>
             <!-- Bind to computed property -->
            <input type="password" v-model="password" placeholder="请输入登录密码" autocomplete="new-password" />
          </div>
        </div>

        <!-- Confirm Password Input (Register Only) -->
        <div class="input-wrapper" v-if="infoType === 1">
          <div class="input-group">
            <!-- <img src="/static/image/hth/password.png" alt="Confirm Password Icon" class="input-icon" /> -->
             <svg width="1.5em" height="1.5em" fill="#999" class="" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="4cf847dfebf12c64dedd56f54eef55f5-clip-path">
                  <path id="4cf847dfebf12c64dedd56f54eef55f5-Union_151" data-name="Union 151" d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"></path>
                </clipPath>
              </defs>
              <g id="4cf847dfebf12c64dedd56f54eef55f5-input_icon_mm" transform="translate(-1283 -2123)">
                <g id="4cf847dfebf12c64dedd56f54eef55f5-底层" transform="translate(1283 2123)">
                  <g id="4cf847dfebf12c64dedd56f54eef55f5-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0" clip-path="url(#4cf847dfebf12c64dedd56f54eef55f5-clip-path)">
                    <path id="4cf847dfebf12c64dedd56f54eef55f5-底层-2" data-name="底层" d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z" transform="translate(0 0)"></path>
                  </g>
                </g>
                <path id="4cf847dfebf12c64dedd56f54eef55f5-icon_dl_mm" d="M3395.9,1308.251v-3.45a13.723,13.723,0,0,0-12.842-13.8,13.492,13.492,0,0,0-14.205,13.4v3.832h-.542a3.307,3.307,0,0,0-3.32,3.293v22.161a3.307,3.307,0,0,0,3.32,3.294h28.129a3.308,3.308,0,0,0,3.32-3.294v-22.161a3.307,3.307,0,0,0-3.32-3.293Zm-22.541-3.514a9.014,9.014,0,1,1,18.027,0v3.515H3373.36Zm11.908,23.534a.943.943,0,0,1-.23.743.973.973,0,0,1-.72.32h-3.862a.973.973,0,0,1-.722-.32.947.947,0,0,1-.23-.742l.61-5.438a3.777,3.777,0,0,1-1.582-3.082,3.863,3.863,0,1,1,7.727,0,3.777,3.777,0,0,1-1.58,3.082Z" transform="translate(-2075.991 833.018)"></path>
              </g>
            </svg>
            <input type="password" v-model="registerInfo.confirmPass" placeholder="确认密码" autocomplete="new-password" />
          </div>
        </div>

        <!-- Real Name Input (Register Only) -->
        <!-- <div class="input-wrapper" v-if="infoType === 1">
          <div class="input-group">
            <img src="/static/image/hth/user.png" alt="Real Name Icon" class="input-icon" />
            <input type="text" v-model="registerInfo.realname" placeholder="真实姓名" />
          </div>
        </div> -->

        <!-- Payment Password Input (Register Only) -->
        <div class="input-wrapper" v-if="infoType === 1">
          <div class="input-group">
            <!-- <img src="/static/image/hth/password.png" alt="Payment Password Icon" class="input-icon" /> -->
             <svg width="1.5em" height="1.5em" fill="#999" class="" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="4cf847dfebf12c64dedd56f54eef55f5-clip-path">
                  <path id="4cf847dfebf12c64dedd56f54eef55f5-Union_151" data-name="Union 151" d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"></path>
                </clipPath>
              </defs>
              <g id="4cf847dfebf12c64dedd56f54eef55f5-input_icon_mm" transform="translate(-1283 -2123)">
                <g id="4cf847dfebf12c64dedd56f54eef55f5-底层" transform="translate(1283 2123)">
                  <g id="4cf847dfebf12c64dedd56f54eef55f5-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0" clip-path="url(#4cf847dfebf12c64dedd56f54eef55f5-clip-path)">
                    <path id="4cf847dfebf12c64dedd56f54eef55f5-底层-2" data-name="底层" d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z" transform="translate(0 0)"></path>
                  </g>
                </g>
                <path id="4cf847dfebf12c64dedd56f54eef55f5-icon_dl_mm" d="M3395.9,1308.251v-3.45a13.723,13.723,0,0,0-12.842-13.8,13.492,13.492,0,0,0-14.205,13.4v3.832h-.542a3.307,3.307,0,0,0-3.32,3.293v22.161a3.307,3.307,0,0,0,3.32,3.294h28.129a3.308,3.308,0,0,0,3.32-3.294v-22.161a3.307,3.307,0,0,0-3.32-3.293Zm-22.541-3.514a9.014,9.014,0,1,1,18.027,0v3.515H3373.36Zm11.908,23.534a.943.943,0,0,1-.23.743.973.973,0,0,1-.72.32h-3.862a.973.973,0,0,1-.722-.32.947.947,0,0,1-.23-.742l.61-5.438a3.777,3.777,0,0,1-1.582-3.082,3.863,3.863,0,1,1,7.727,0,3.777,3.777,0,0,1-1.58,3.082Z" transform="translate(-2075.991 833.018)"></path>
              </g>
            </svg>
            <input type="password" v-model="registerInfo.paypassword" placeholder="支付密码" autocomplete="new-password" />
          </div>
        </div>

        <!-- Login Button (Login Only) -->
        <button class="action-button login-button" @click="login()" v-if="infoType === 0">登 录</button>

        <!-- Register Button (Register Only) -->
        <button class="action-button register-button" @click="register()" v-if="infoType === 1">注 册</button>
      </div>

      <!-- Bottom Links Area -->
      <div class="bottom-links-area">
        <!-- Login Bottom Links (Login Only) -->
        <div class="bottom-links login-bottom-links" v-if="infoType === 0">
          <!-- <div class="link-item" @click="changInfoType(1)">
            <img src="/static/image/hth/register.png" alt="Register" />
            <span>立即注册</span>
          </div> -->
          <div class="link-item" @click="guestLogin()">
            <!-- <img src="/static/image/hth/travelers.png" alt="Guest" /> -->
            <span>游客进入</span>
          </div>
          <div class="link-item" @click="forgotPassword()">
            <!-- <img src="/static/image/hth/customer.png" alt="Forgot Password" /> -->
            <span>找回账号</span>
          </div>
        </div>

        <!-- Register Bottom Links (Register Only) -->
        <div class="bottom-links register-bottom-links" v-if="infoType === 1">
          <!-- <div class="link-item" @click="changInfoType(0)">
            <img src="/static/image/hth/register.png" alt="Login" />
            <span>前往登陆</span>
          </div> -->
          <div class="link-item" @click="guestLogin()">
            <!-- <img src="/static/image/hth/travelers.png" alt="Guest" /> -->
            <span>游客进入</span>
          </div>
          <div class="link-item" @click="forgotPassword()">
            <!-- <img src="/static/image/hth/customer.png" alt="Forgot Password" /> -->
            <span>找回账号</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div id="app-footer">
       <!-- Existing Footer Content -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      registerInfo: { name: '', password: '', confirmPass: '', realname: '', paypassword: '' },
      loginInfo: { name: '', password: '' },
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0,
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      isRegistering: false,
      active:1
    };
  },
  computed: {
    username: {
      get() {
        return this.infoType === 0 ? this.loginInfo.name : this.registerInfo.name;
      },
      set(value) {
        if (this.infoType === 0) {
          this.loginInfo.name = value;
        } else {
          this.registerInfo.name = value;
        }
      }
    },
    password: {
      get() {
        return this.infoType === 0 ? this.loginInfo.password : this.registerInfo.password;
      },
      set(value) {
        if (this.infoType === 0) {
          this.loginInfo.password = value;
        } else {
          this.registerInfo.password = value;
        }
      }
    }
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = parseInt(query.type);
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    if(query.type == 1){
      this.active = 0
      this.changeTab()
    }
  },
  methods: {
    changeTab(){
      if(this.active == 0){
        this.changInfoType(1)
      }else{
        this.changInfoType(0)
      }
    },
    handleContainerClick(event) {
      const isInput = event.target.tagName === 'INPUT' || 
                     event.target.closest('.input-group');
      
      if (!isInput) {
        document.activeElement.blur();
      }
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;
      let info = that.registerInfo;

      if (that.isRegistering) {
        that.$parent.showTost(0, '注册请求已提交，请勿重复操作！');
        return;
      }

      // Username Validation
      const usernameRegex = /^[a-z0-9]{5,11}$/;
      if (!info.name || !usernameRegex.test(info.name)) {
        that.$parent.showTost(0, ' 用户名需为5-11位小写字母或数字组合！');
        return;
      }

      // Password Validation
      if (!info.password || info.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      if (!info.confirmPass || info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }

      // Re-added Real Name Validation
      //if (!info.realname || info.realname.length < 2) {
        //that.$parent.showTost(0, '请输入您的真实姓名!');
        //return;
      //}

      // Re-added Payment Password Validation
      if (!info.paypassword || info.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
        return;
      }

      that.$parent.showLoading();
      that.isRegistering = true;

      // Construct data to send (including re-added fields)
      let registerData = {
          name: info.name,
          password: info.password,
          confirmPass: info.confirmPass,
          realname: info.realname,
          paypassword: info.paypassword,
          ...(that.pid && { pid: that.pid })
      };

      that.$apiFun.register(registerData).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();
          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
        that.isRegistering = false;
      }).catch(err => {
          console.error("Registration failed:", err);
          that.$parent.showTost(0, '注册失败，请稍后再试。');
          that.$parent.hideLoading();
          that.isRegistering = false;
      });
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          return;
        }
        sessionStorage.setItem('token', res.data.api_token);
        that.$store.commit('changToken');
        that.$parent.getUserInfo();
        that.$parent.openDaoTime();
        that.$parent.refreshBalance();
        that.$parent.goNav('/');
        that.$parent.hideLoading();
      }).catch(err => {
          console.error("Login failed:", err);
          that.$parent.showTost(0, '登录失败，请稍后再试。');
          that.$parent.hideLoading();
      });
    },
    guestLogin() {
      this.$parent.goNav('/');
      console.log("Guest Login clicked");
    },
    forgotPassword() {
      console.log("Forgot Password clicked");
      this.$parent.openKefu();
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
/* Remove existing styles and add new ones */
/* Import or define base styles if needed */

/* Apply background image */
.login-register-container {
  position: relative;
  width: 100%;
  min-height: 100vh; /* Ensure it covers the full viewport height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Align items to the top */
  padding-top: 4vh; /* Adjusted top padding */
  box-sizing: border-box;
  overflow: hidden; /* Hide overflow from background */
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/static/image/img_login_bg_style3.avif');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1; /* Place background behind content */
  filter: brightness(0.6); /* Adjusted brightness */
  
}

/* Login View Specific Styles */
.login-view {
  width: 85%;
  max-width: 380px; /* Reverted max-width */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1; /* Ensure content is above background */
}

/* Top Logo Styles */
.top-logo-container {
  display: flex;
  // flex-direction: column; /* Stack logo and text vertically */
  align-items: center;
  margin-bottom: 25px; /* Adjusted space */
}

.top-logo {
  width: 55px; /* Adjusted size */
  height: auto;
  margin-bottom: 8px; /* Adjusted space */
}

.logo-text {
  color: #866638;
  font-size: 22px; /* Adjusted size */
  font-weight: bold;
  padding-left: 6px;
  .url{
    color: #0a2a9b;
    font-size: 18px;
  }
}

/* Partner Block Styles */
.partner-block {
  width: 100%;
  border-radius: 20px; /* Keep border-radius */
  margin-bottom: 25px; /* Keep space */
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25); /* Keep shadow */
  position: relative;
  overflow: hidden; /* Ensure image respects border-radius */
}

/* New style for the combined partner image */
.partner-image {
  display: block; /* Remove extra space below image */
  width: 100%;   /* Make image fill the container */
  height: auto;  /* Maintain aspect ratio */
}

/* Login Form Styles */
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Removed padding and box-sizing */
}

.input-group {
  width: 100%;
  height: 36px; /* Explicit height */
  // background-color: rgba(50, 50, 50, 0.3); /* Adjusted background */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 6px; /* Adjusted border-radius */
  margin-bottom: 18px; /* Adjusted space */
  display: flex;
  align-items: center;
  padding: 0 10px; /* Adjusted padding */
  // box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border: 1px solid #e3e3e3;
}

.input-icon {
  width: 18px; /* Adjusted size */
  height: 18px;
  margin-right: 12px; /* Adjusted space */
  color: #666;
  // opacity: 0.6; /* Adjusted opacity */
}

.input-group input {
  flex-grow: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #666;
  font-size: 13px; /* Adjusted size */
  // padding: 15px 0; /* Keep vertical padding */
  height: 100%; /* Ensure input fills height */
  line-height: normal; /* Reset line-height */
}

.input-group input::placeholder {
  color: #b0b0b0; /* Adjusted color */
  opacity: 1;
}

.login-button {
  width: 100%;
  height: 55px; /* Explicit height */
  /* Updated background color to gradient */
  background: linear-gradient(to bottom, #d8c2a9, #c8ae8f); /* Light brown/gold gradient */
  color: #ffffff;
  border: none;
  border-radius: 20px; /* Adjusted border-radius */
  padding: 0; /* Reset padding */
  font-size: 17px; /* Adjusted size */
  font-weight: 600; /* Adjusted weight */
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
  letter-spacing: 4px; /* Added letter spacing */
  display: flex; /* Center text */
  align-items: center;
  justify-content: center;
}

.login-button:hover {
  /* Adjusted hover background */
  background: linear-gradient(to bottom, #c8ae8f, #b89a76); /* Darker gradient on hover */
}

/* Bottom Links Styles */
.bottom-links {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start; /* Align items to top to match image */
  // margin-top: 15px; /* Adjusted space */
  padding: 0 10px; /* Add some horizontal padding */
}

.link-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;
  flex: 1; /* Allow items to take equal space */
}

.link-item img {
  width: 28px; /* Adjusted icon size */
  height: 28px;
  margin-bottom: 6px; /* Adjusted space */
  opacity: 0.9; /* Adjusted opacity */
}

.link-item span {
  color: #866638; /* Adjusted color (brighter) */
  font-size: 12px; /* Keep size */
  font-weight: 500;
}

/* --- Keep existing styles for registration view and footer --- */
.registration-view {
  /* Existing styles... */
}

#app-footer {
  /* Existing styles... */
  /* Ensure footer is positioned correctly relative to the new layout */
  /* You might need to adjust its position/styling if it overlaps */
   position: absolute; /* Example: fix to bottom if needed */
   bottom: 0;
   width: 100%;
   /* ... other existing footer styles ... */
   display: none; /* Hide footer in login view as per image */
}

/* Ensure footer visibility is handled correctly based on view if needed elsewhere */
.login-register-container:has(.login-view) #app-footer {
  display: none;
}

/* Common Header Styles */
.common-header {
  width: 85%; /* Adjusted width */
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.return-link {
    width: 100%;
    text-align: left;
    color: #b0b0b0;
    font-size: 14px;
    margin-bottom: 15px; /* Space below return link */
    cursor: pointer;
    padding-left: 10px; /* Align roughly with form */
}

.register-form {
   margin-bottom: 20px; /* Add margin at the bottom if needed */
}

/* Input Styles (Shared) - Ensure margin is on wrapper */
.input-wrapper {
  width: 100%;
  // margin-bottom: 15px; /* Consistent spacing */
}

.input-hint {
  color: red;
  font-size: 11px;
  padding-left: 20px;
  position: absolute;
  bottom: -16px;
  // margin-top: 5px;
}

/* Action Button Styles (Shared) - Re-applying for certainty */
.action-button {
  width: 100%;
  height: 40px;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  // transition: background-color 0.3s ease, background 0.3s ease;
  // box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
    margin-top: 10px;
}

/* Login Button styles - Keep as is */
.login-button {
  background: #866638;
}

.login-button:hover {
  background: linear-gradient(to bottom, #c8ae8f, #b89a76);
}

/* Register Button - Apply same styles as Login Button */
.register-button {
  /* Use the same gradient background as login */
  background: #866638;
}

.register-button:hover {
   /* Use the same darker gradient on hover as login */
   background: linear-gradient(to bottom, #c8ae8f, #b89a76);
}

/* Bottom Links General Styles */
.bottom-links {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  // margin-top: 20px; /* Adjusted margin for spacing */
  padding: 0 10px;
}

.link-item {
  /* ... (link-item base styles remain the same) ... */
}

.link-item img {
 /* ... (img styles remain the same) ... */
}

.link-item span {
  /* ... (span styles remain the same) ... */
}

/* Remove Registration View Specific Return Link Style */
/* .return-link { ... } */

/* Footer Hiding Logic - Keep as is */
#app-footer {
   position: absolute;
   bottom: 0;
   width: 100%;
   display: none;
}

/* Unified View Container Styles */
.unified-view {
  width: 85%; /* Use same width as header */
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
}

/* Unified Form Styles */
.unified-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
   margin-bottom: 20px; /* Space below form before links */
}

/* Bottom Links Area Styles */
.bottom-links-area {
    width: 100%;
    // margin-top: 15px; /* Consistent margin above links */
}
.wel{
    color: #866638;
    font-weight: bold;
    font-size: 24px;
    text-align: center;
  }
  .van-tabs{
    width: 100%;
    border-bottom: 1px solid #dddddd;
    margin-bottom: 20px;
    
  }

</style>



// WEBPACK FOOTER //
// src/components/login.vue